import React, {PropTypes} from 'react';
import classNames from 'classnames';

const StatusItem = ({
  active,
  status,
  onSetStatusClick,
  hasPendingChanges
}) => (
  <div className={classNames(
      'list-group-item-labeled',
      {'highlight': active}
    )}>
    <div className="list-group-item-labeled-child"
      style={{width: 300}}>
      <span>{`Status${active ? ' (Current)' : '' }`}</span>
      <span>{status}</span>
    </div>
    {active
      ? null
      : <div className="list-group-item-labeled-child"
          style={{width: 150}}>
          <button className="btn btn-link"
            type="button"
            onClick={() => onSetStatusClick(status)}
            disabled={hasPendingChanges}>
            <i className="fa fa-wrench" /> {'Update Status'}</button>
        </div>
    }
  </div>
);

StatusItem.propTypes = {
  active: PropTypes.bool,
  status: PropTypes.string,
  onSetStatusClick: PropTypes.func,
  hasPendingChanges: PropTypes.bool
};

export default StatusItem;



// WEBPACK FOOTER //
// ./src/features/tournament/status/StatusItem.jsx